/** Minimal typed pub/sub. No dependencies, no allocation on emit. */
export class Emitter<T> {
  private listeners = new Set<(v: T) => void>();

  on(fn: (v: T) => void): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  emit(v: T): void {
    for (const fn of this.listeners) {
      try {
        fn(v);
      } catch (err) {
        // A broken subscriber must never take down the ingest path.
        console.error('[emitter] listener threw', err);
      }
    }
  }

  get size(): number {
    return this.listeners.size;
  }

  clear(): void {
    this.listeners.clear();
  }
}
